import React from "react";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import { SectionHeading } from "../SectionHeading/SectionHeading";
import ProjectThumbnail from "./ProjectThumbnail/ProjectThumbnail";
import selectProjects from "../../selectors/projects";
import "./projects.css";

export const Projects = props => (
  <Container fluid className="no-gutters px-0" id="work" name="work">
    <SectionHeading title="Film" />
    <Row className="no-gutters">
      {props.films.map(film => (
        <ProjectThumbnail key={film.id} {...film} />
      ))}
    </Row>
    <SectionHeading title="Ads" />
    <Row className="no-gutters">
      {props.ads.map(ad => {
        return <ProjectThumbnail key={ad.id} {...ad} />;
      })}
    </Row>
  </Container>
);

const mapStateToProps = state => {
  return {
    films: selectProjects(state.projects, "film"),
    ads: selectProjects(state.projects, "advertisement")
  };
};

export default connect(mapStateToProps)(Projects);



// WEBPACK FOOTER //
// ./src/components/Projects/Projects.js